/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 09:50:12
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-13 22:20:32
 */

// const url = process.env.BASE_URL

export default {
	version: '1.0.0',
	ossDomain: process.env.VUE_APP_OSS_DOMAIN, // oss域名
	ossAppDir: 'xladmin', // oss目录z
	uniBaseURL: process.env.VUE_APP_UNI_BASEURL, // html5链接
	pageSize: 10, // 分页条数
	tokenTime: 60 * 60 * 1000,
	loginAppId: '3c9a1563796c401183c6a441f5b96e1b',
	verificateAppId: 'fcc3fd8ddfb14cd68c54c0cc34f63bd6',
	// 多域名静态资源配置
	initDomain: {
		'default': {
			ename: "manage",
			type: "manage",
			title: "快活龙审核中台",
			domain: "hr.test.51xinlong.com",
			logo: "/static/images/default/logo.png",
			logoTop: "",
			logoLogin: "/static/images/default/logo.png",
			backgroundImg: "/static/images/default/banner.jpg",
			icoUrl: "/static/images/default/default.ico",
			siderLogo: "/static/images/default/siderLogo.png",
			appQR: "/static/images/default/QRCode.jpg",
			location: '杭州',
			appId: '888', //测试999，正式888 请勿随意更改
			settlmentlCustom: {
				companyIds: [148834054111420416],
				originName: '江西省顺捷信息技术服务有限公司',
				currentName: '芜湖创晖信息技术有限公司',
				paymentAccount: '34050167680800000599',
				bankOfDeposit: '中国建设银行股份有限公司芜湖弋江支行',
				taxRate: '6',
				placeholder: '***'
			}
		}
	}
}
